import { FunctionComponent, useCallback } from 'react';
import { CustomButton } from '@foxtrotplatform/developer-platform-common-ui-component-lib';

export const DoneProcessingBackButton: FunctionComponent = () => {
  const onClick = useCallback(() => {
    sessionStorage.clear();
    window.location.href = 'https://getos1.com';
  }, []);

  return (
    <CustomButton
      actionType="primary"
      onClick={onClick}
      testId="done-back-btn"
      className="px-6"
    >
      <span className="font-bold">Done</span>
    </CustomButton>
  );
};
